import styled from 'styled-components';
import { xdlColorTextSecondary } from '@xingternal/tokens';
import { BodyCopy } from '../';
// *** Components ***
const Meta = styled(BodyCopy) `
  color: ${xdlColorTextSecondary};
`;
export const Styled = {
    Meta,
};
//# sourceMappingURL=meta.styles.js.map